import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { getInvoiceDocumentRouteBase } from '@features/invoices/utils/getInvoiceDocumentRouteBase'

import { invoiceEditorVariantDocumentTypes } from '../constants/variants/invoiceEditorVariantDocumentTypes'
import { InvoiceEditorVariant } from '../enums/invoiceEditorVariant'

const invoicesRelatedRoutes = [
  getInvoiceDocumentRouteBase(InvoiceDocumentType.Invoice),
  getInvoiceDocumentRouteBase(InvoiceDocumentType.RecurringInvoice),
]

const getIsInvoicesRelatedRoute = (route: string) => invoicesRelatedRoutes.includes(route)

export const getIsEditorVariantRecurringInvoicesSwitch = (
  previousVariant: InvoiceEditorVariant,
  currentVariant: InvoiceEditorVariant,
): boolean => {
  const previousVariantRouteBase = getInvoiceDocumentRouteBase(
    invoiceEditorVariantDocumentTypes[previousVariant].documentType,
  )
  const currentVariantRouteBase = getInvoiceDocumentRouteBase(
    invoiceEditorVariantDocumentTypes[currentVariant].documentType,
  )

  return (
    getIsInvoicesRelatedRoute(previousVariantRouteBase) &&
    getIsInvoicesRelatedRoute(currentVariantRouteBase) &&
    previousVariantRouteBase !== currentVariantRouteBase
  )
}
